import { api } from "../../lib";

export interface InsuranceProviderPlanType {
  id: string;
  insuranceProviderId: string;
  insurancePlanTypeId: string;
  allowSplitBilling: boolean;
  tebraCompanyId: number | null;
  tebraPlanId: number | null;
  createdAt: string;
  updatedAt: string;
  insuranceProvider?: {
    name: string;
  };
  insurancePlanType?: {
    type: string;
  };
}

export interface CreateInsuranceProviderPlanTypeInput {
  insuranceProviderId: string;
  insurancePlanTypeId: string;
  allowSplitBilling?: boolean;
  tebraCompanyId?: number | null;
  tebraPlanId?: number | null;
}

export interface UpdateInsuranceProviderPlanTypeInput {
  id: string;
  allowSplitBilling?: boolean;
  tebraCompanyId?: number | null;
  tebraPlanId?: number | null;
}

export const insuranceProviderPlanTypesService = {
  getAll: async () => {
    return api.get<InsuranceProviderPlanType[]>(
      "/admin/insurance-provider-plan-types"
    );
  },

  getById: async (id: string) => {
    return api.get<InsuranceProviderPlanType>(
      `/admin/insurance-provider-plan-types/${id}`
    );
  },

  getByProviderId: async (providerId: string) => {
    return api.get<InsuranceProviderPlanType[]>(
      `/admin/insurance-providers/${providerId}/plan-types`
    );
  },

  create: async (input: CreateInsuranceProviderPlanTypeInput) => {
    return api.post<InsuranceProviderPlanType>(
      "/admin/insurance-provider-plan-types",
      input
    );
  },

  update: async (input: UpdateInsuranceProviderPlanTypeInput) => {
    const { id, ...updates } = input;
    return api.put<InsuranceProviderPlanType>(
      `/admin/insurance-provider-plan-types/${id}`,
      updates
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/insurance-provider-plan-types/${id}`);
  },
};
